import React, { Fragment } from 'react'
import { Table } from 'react-bootstrap'
import { FiMinus, FiPlus } from 'react-icons/fi'
import { RxCross2 } from 'react-icons/rx'
import { Link } from 'react-router-dom'
import useCartDetail from '../../Hooks/Cart/useCartDetail'
import OrderSummary from './OrderSummary'

const CartDetail = () => {

    const [
        cartItems,
        isLoading,
        code,
        handleDecreament,
        handleIncreament,
        handleRemove,
        totalAmount, // replace calculatePrice with totalAmount
        removeAll,
        handleSubmit,
        handleCode,
        discountAmount,
        totalAmountNumeric,
        user,
    ] = useCartDetail();

    return (
        <Fragment>
            <div className="container my-5 cart">
                <div className="row justify-content-between">
                    <div className="col-lg-7">
                        <Table size="sm">
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>Subtotal</th>
                                    <th className='visiblity-hidden'></th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(cartItems?.cart) && cartItems?.cart?.length > 0 ? (
                                    <>
                                        {cartItems?.cart?.map((item, i) => (
                                            <tr className=''>
                                                <td className='d-flex align-items-center '>
                                                    <img src={item?.img} className='rounded' width={58} height={58} alt="" />
                                                    <p className='fw-600 s-17 mb-0 ps-2'>{item?.title}</p>
                                                </td>
                                                <td>{item?.price}</td>
                                                <td>

                                                    <div className="row g-2  ">
                                                        <div className="col-auto">
                                                            <button className='btn-sm btn btn-danger p-0 cart-count ' >
                                                                <FiPlus onClick={() => { handleIncreament(item) }} size={20} />
                                                            </button>
                                                        </div>
                                                        <div className="col-auto">
                                                            <div className='rounded cart-count text-light bg-dark'>{item?.quantity}</div>
                                                        </div>
                                                        <div className="col-auto">

                                                            <button
                                                                className='btn-sm btn btn-danger cart-count p-0  '>
                                                                <FiMinus onClick={() => { handleDecreament(item) }} size={20} />
                                                            </button>
                                                        </div>
                                                    </div>

                                                </td>
                                                <td>{item?.price * item?.quantity}</td>
                                                <td>
                                                    <RxCross2 onClick={() => { handleRemove(item) }} className='cursor-pointer' size={18} />
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan="5" className="text-end fw-bold s-28">
                                                <div className="row">
                                                    <div className="col text-start">
                                                        <button className='btn btn-danger'>
                                                            Update Cart
                                                        </button>
                                                    </div>

                                                    <div className="col-auto">
                                                        Total $ {totalAmount}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr className=''>
                                            <td colSpan="5" className=" text-end fw-bold s-28">
                                                <div className="row">
                                                    <div className="col text-start">
                                                        <button onClick={removeAll} className='btn btn-dark'>
                                                            Clear Cart
                                                        </button>
                                                    </div>

                                                    <div className="col text-end" >
                                                        {user ? <>
                                                            <Link to={"/checkout"} className='btn btn-danger'>
                                                                Proceed to Checkout
                                                            </Link>
                                                        </> : <>
                                                            <Link to={"/login"} className='btn btn-danger'>
                                                                Sign In to Place Order
                                                            </Link>
                                                        </>}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                )
                                    : ("No data found")}

                            </tbody>
                        </Table>


                    </div>


                    <div className="col-lg-4">
                        <OrderSummary />
                    </div>
                </div>
            </div>
        </Fragment >
    )
}

export default CartDetail